import React from "react";
import { transformVar } from "@quarkly/atomize";
import { createGlobalStyle } from "styled-components";

const pageStyles = {
    "404": {
        "background": "",
        "color": "#ffe5ee",
        "font": "16px --fontFamily-googlePermanentMarker"
    },
    "index": {
        "background": "",
        "color": "#ffe5ee",
        "font": "16px --fontFamily-googlePermanentMarker"
    }
};

const PageStyles = createGlobalStyle`
    body {
        ${({ styles }) =>
            Object.entries(styles || {}).map(
                ([prop, value]) => `${prop}: ${transformVar(prop, value)};`
            )}
    }
`;
export const GlobalQuarklyPageStyles = ({ pageUrl }) => <PageStyles styles={pageStyles[pageUrl]} />
